module.exports = __webpack_public_path__ + "img/0Q3A8622_L_BlackMatted.8a66c880.jpg";